import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { PropertyCategoryEnum } from '../../common/propertyCategory.enum';

@Component({
  selector: 'app-power-bi-property-details',
  templateUrl: './power-bi-property-details.component.html',
  styleUrls: ['./power-bi-property-details.component.scss']
})
export class PowerBiPropertyDetailsComponent {

  @Input() property:any;

  public params: any;
  public currentScroll = 0;
  public PowerBIData: any;
  public embedData: any;
  public catchmentCount: number = 0;
  currentLang: string = '';
  languageSub$: Subscription = new Subscription();

  residentialProp:boolean = false;
  officeProp:boolean = false;
  retailProp:boolean = false;
  houseVillaProp:boolean = false;
  warehouseProp:boolean = false;
    constructor(
      private sharedService: SharedService,
      public translate: TranslateService,
      public reportService: ReportService,
      private route: ActivatedRoute
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
      this.route.queryParams.subscribe(param => {
        this.params = param;

      })
     this.getPropertyConfig();
    }

    setLang(): void {
      this.languageSub$ = this.sharedService.language$.subscribe(lang => {
        this.currentLang = lang;
      })
    }

    async getPropertyConfig(){

      this.residentialProp = false;
      this.officeProp = false;
      this.retailProp = false;
      this.houseVillaProp = false;
      this.warehouseProp = false;
      let paramcat: string[] = [];
      const categoryParam = this.params['property_category'] || this.params['property_cat_subcat'];
      if (categoryParam) {
        paramcat = categoryParam.toLowerCase().split(',');
      }
      let propcat = this.property?.property_category?.toLowerCase() || null;

      let categ = paramcat?.find((item:string)=> propcat?.includes(item) ) || propcat?.split(',')[0]
      if(categ){
        if (categ == PropertyCategoryEnum.MultiStoryResidential) {
          this.residentialProp = true;
        } else if (categ == PropertyCategoryEnum.MultiStoryOffice) {
          this.officeProp = true;
        } else if (categ == PropertyCategoryEnum.RetailFbAndEntertainment) {
          this.retailProp = true;
        } else if (categ == PropertyCategoryEnum.VillaHouse) {
          this.houseVillaProp = true;
        } else if (categ == PropertyCategoryEnum.IndustryWorkshopWarehouse) {
          this.warehouseProp = true;
        }
      }
        this.reportService.detailPageState$.next(true);
    }


    ngOnInit(): void {
      this.setLang();
    }

    // loadVisualReport(){
    //   this.reportService.powerBiFecthReport(this.PowerBIData.pb_group_id, this.PowerBIData.pb_report_id)
    //     .subscribe({
    //       next: (res: any) =>{
    //         this.embedData = res.data;
    //       },
    //       error: (err)=>{
    //       }
    //     })
    // }


    menuChangeValue(menu: any) {
      this.currentScroll = menu.name;
      setTimeout(() => {
        this.scrollPoint(menu.name);
      })
    }

    scrollPoint(menu: string) {
      this.sharedService.scrollMenu(menu);
    }

    backToReport(){
      this.reportService.transactionPropertyDetails.next(false);
    }
    ngOnDestroy(): void {
      this.languageSub$?.unsubscribe()
    }
}
